import React, { useRef, useState, useEffect } from 'react';
import confApi from '../../Config/Api'
import {Recorder} from './Recorder'


function Perekam({ recording, onRecordingToggle, transcribe, setJawaban, setReadySend, setRecordedChunks, onError }) {
    const videoRef = useRef(null);
    const [mediaRecorder, setMediaRecorder] = useState(null);
    const [speechRecognition, setSpeechRecognition] = useState(null);
    const [transcript, setTranscript] = useState('');

    const [menjawab, setMenjawab] = useState(false);
    const [finalTranscript, setFinalTranscript] = useState('');
    const [recorder, setRecorder] = useState(null);  

    useEffect(() => {
        setupCamera()
        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
            return;
        }

        const AudioContextConstructor = window.AudioContext || window.webkitAudioContext;
        if (!AudioContextConstructor) {
            return;
        }

        navigator.mediaDevices.getUserMedia({ audio: true })
            .then(stream => {
                const audioContext = new AudioContextConstructor();
                const source = audioContext.createMediaStreamSource(stream);
                const newRecorder = new Recorder(source);
                setRecorder(newRecorder);
            })
            .catch(err => {
                console.error('Error accessing the microphone:', err);
            });
    }, []);

    useEffect(() => {
        if (recording) {
            startRecording();
        } else if (recording === 'close')
        {
            stopRemoveRecording();
        }
         else if (mediaRecorder) {
            stopRecording();
        }
    }, [recording]);

    useEffect(() => {
        if (transcribe) {
            startSpeechRecognition();
        } else if (mediaRecorder) {
            stopSpeechRecognition();
        }
    }, [transcribe]);

    useEffect(() => {
        if (finalTranscript) {
            setJawaban(finalTranscript)
            setFinalTranscript(null)
        }
    }, [finalTranscript]);

    const setupCamera = async () => {
        try {
            if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
                throw new Error('Kamera tidak didukung oleh browser ini.');
            }

            let stream;
            try {
                stream = await navigator.mediaDevices.getUserMedia({video: {
                    facingMode: { ideal: 'user' },
                    width: { max: 320 },
                    height: { max: 240 },
                    frameRate: { max: 15 }
                }});
            } catch (error) {
                stream = await navigator.mediaDevices.getUserMedia({video: {
                    facingMode: 'user'
                }});
            }

            if (videoRef.current) {
                videoRef.current.srcObject = stream;
                await videoRef.current.play();
            } else {
                stream.getTracks().forEach(track => track.stop());
            }
        } catch (err) {
            console.error('Error accessing camera:', err);
        }
    }

    const startSpeechRecognition = () => {
        if (recorder) {
            recorder.record();      
        }
    };

    const stopSpeechRecognition = () => {
        if (recorder && recorder.recording) {
            recorder.stop();
      
            recorder.exportWAV(async (blob) => {
              await transcribeAudio(blob)
              recorder.clear();
            });      
        }
    };

    const transcribeAudio = async (blob) => {
      const reader = new FileReader();
      const dataForm = new FormData();
 
      reader.readAsDataURL(blob);
  
      reader.onloadend = async () => {
          // const base64data = reader.result;
          // const audio = { content: '' };
  
          // const config = {
          //   encoding: 'LINEAR16',
          //   languageCode: 'id-ID',
          //   sampleRateHertz: 48000
          // };
  
          // const data = {
          //   config,
          //   audio
          // };
        
          // audio.content = base64data.substr(base64data.indexOf(',') + 1);
 
          dataForm.append("videoBlob", blob);
          console.log("data",dataForm)
          const apiUrl = confApi.host+'/'+confApi.routeVidConvert+'/vidconvert/speechToText';
  
        const googleCloudRes = await fetch(
              apiUrl,
          {
            method: 'POST',
            body: dataForm
          }
        );

        const googleCloudJson = await googleCloudRes.json();
        if (googleCloudJson.length > 0) {
          const { transcript:dataHasil } = googleCloudJson[0].alternatives[0];
          if(dataHasil && dataHasil !== undefined && dataHasil !== null)
          {
            setFinalTranscript(dataHasil)
          }
          else
          {
            setFinalTranscript('Speech To Text Not Response..')
          }
        }else{
          setFinalTranscript('Speech To Text Not Response..')
        }
      };
    };
  

    const startRecording = () => {
        const stream = videoRef.current && videoRef.current.srcObject;
        if (!stream || !window.MediaRecorder) {
            onError && onError(new Error('Perekaman video tidak didukung atau kamera belum siap.'));
            return;
        }

        let recorder;
        try {
            recorder = new window.MediaRecorder(stream);
        } catch (error) {
            onError && onError(error);
            return;
        }
        setMediaRecorder(recorder);

        recorder.ondataavailable = (event) => {
            setRecordedChunks((prevChunks) => [...prevChunks, event.data]);
        };
        recorder.onstop = () => {
            setReadySend(true)
        }

        recorder.start();
    };

    const stopRecording = () => {
        if (mediaRecorder && mediaRecorder.state !== 'inactive') {
            mediaRecorder.stop();
        }
    };

    const stopRemoveRecording = () => {
        if (mediaRecorder && mediaRecorder.state !== 'inactive') {
            mediaRecorder.stop();
        }
        setRecordedChunks([]);
    };


    return (
        <div className="App" style={{display:'none'}}>
            <header className="App-header">
                <video ref={videoRef} width="480" height="360" autoPlay muted playsInline></video>
                <div>
                    <button onClick={startRecording}>start Recording</button>
                    <button onClick={stopRecording}>stop Recording</button>
                </div>
                <div>
                    <button onClick={startSpeechRecognition}>Start Speech Recognition</button>
                    <button onClick={stopSpeechRecognition}>Stop Speech Recognition</button>
                </div>
                <div>
                    <h2>Transcript</h2>
                    <p>{transcript}</p>
                </div>
            </header>
        </div>

    );
}

export default Perekam;